export default __webpack_public_path__ + "static/media/aws.ce8885eb.jpg";